import {observer} from 'mobx-react';
import {ReorderModal} from 'shared/components/modals';

const ReorderDimensionsModal = observer(({modalOpen, uiState}) => {
  return (
    <ReorderModal
      isOpen={modalOpen}
      onHide={() => uiState.closeReorderDimensionsModal()}
      title='time_tracking.dimensions.Reorder Dimensions'
      models={uiState.reorderingDimensions}
      onSave={() => uiState.saveDimensionOrders()}
      onCancel={() => uiState.closeReorderDimensionsModal()}
    />
  );
});

export default ReorderDimensionsModal;
